<template lang="pug">
.title-wrap(v-if="blok" v-editable="blok" :style="{ textAlign: $viewport.isLessThan('tablet') ? 'left' : blok.align, padding: $viewport.isLessThan('tablet') && blok.mobile_padding ? blok.mobile_padding : blok.padding, maxWidth: blok.max_width + 'px' }")
	h1(v-if="blok.size === 'h1'" :class="[blok.size, `font-basier-${blok.font_weight}`, blok.no_margin ? `no-margin` : ``]" v-html="title")
	h2(v-else-if="blok.size === 'h2'" :class="[blok.size, `font-basier-${blok.font_weight}`, blok.no_margin ? `no-margin` : ``]" v-html="title")
	h3(v-else="blok.size === 'h3'" :class="[blok.size, `font-basier-${blok.font_weight}`, blok.no_margin ? `no-margin` : ``]" v-html="title")
</template>

<script setup lang="ts">
const { $viewport } = useNuxtApp()
const props = defineProps({
	blok: {
		required: true,
		type: Object
	}
})

const title = ref('')

const updateTitle = () => {
	const blokTitle = props.blok.text
	if (blokTitle?.includes('{') && blokTitle?.includes('}')) {
		let formattedTitle = blokTitle
		formattedTitle = formattedTitle.replace('{', `<span class="${props.blok.size} green">`)
		formattedTitle = formattedTitle.replace('}', '</span>')
		title.value = formattedTitle
	} else {
		title.value = blokTitle
	}
}

// Watch for changes in props.blok.text to update title
watch(() => props.blok, updateTitle, { immediate: true })
</script>

<style lang="sass" scoped>
.title
	margin: 0 auto

.h1,.h2,.h3
	hyphens: manual
	&.no-margin
		margin-bottom: 0
.h1
	@include fontSize(4xl)
.h2
	@include fontSize(3xl)
.h3
	@include fontSize(xxl)
:deep(.green)
	font: inherit
	color: $color-green-60
@media (min-width: $tablet)
	.h1
		@include fontSize(6xl)
	.h2
		@include fontSize(4xl)
	.h3
		@include fontSize(3xl)
</style>
